/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext, useRef, useState, useEffect } from 'react';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from './ErrorBoundary';
import GeneralNavbar from './GeneralNavbar';
import ContactUsImg from '../../assets/contactus.svg';
import Footer from './Footer';


const ServiceRequest = props => {

    // contexts
    const { theme, fontFamily, fontWeight, colors } = useContext(ThemeContext);

    // states
    const [serviceRequest, setServiceRequest] = useState({
        requester: {
            name: '',
            email: ''
        },
        institution: {
            name: '',
            email: ''
        },
        requestedService: '',
        message: ''
    });
    const [requestedServiceName, setRequestedServiceName] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    //refs
    const recaptchaRef = useRef(null);

    //scroll to top
    useEffect(() => {
        window.scrollTo(0, 0);
        document.getElementById("name").focus();


        setIsLoading(true);

        setRequestedServiceName(props.location.state.serviceName);
        setServiceRequest({ ...serviceRequest, requestedService: props.location.state.serviceId })


        setIsLoading(false);

    }, []);

    // handle functions
    const handleChange = e => {

        try {
            let requestDetails = { ...serviceRequest }
            if (e.target.name === 'name') {
                requestDetails.requester.name = e.target.value;
                setServiceRequest(requestDetails)
            }
            if (e.target.name === 'email') {
                requestDetails.requester.email = e.target.value;
                setServiceRequest(requestDetails)
            }
            if (e.target.name === 'institution-name') {
                requestDetails.institution.name = e.target.value;
                setServiceRequest(requestDetails)
            }
            if (e.target.name === 'institution-email') {
                requestDetails.institution.email = e.target.value;
                setServiceRequest(requestDetails)
            }
            if (e.target.name === 'message') {
                setServiceRequest({ ...serviceRequest, message: e.target.value })
            }
            setServiceRequest({ ...serviceRequest, [e.target.name]: e.target.value });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at General ContactUs handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {
        e.preventDefault();

        try {

            setIsLoading(true);
            GeneralService.postServiceRequest(serviceRequest)
                .then(data => {
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                })
                .then(data => {
                    setServiceRequest({
                        requester: {
                            name: '',
                            email: ''
                        },
                        institution: {
                            name: '',
                            email: ''
                        },
                        requestedService: '',
                        message: ''
                    });
                    setIsLoading(false);
                    props.history.push('/');
                });

        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading(false);
            GeneralService.logError('at General Service Request handleSubmit', 'Error in try catch block', err.stack);
        }
    }

    //utility function


    return (
        <div style={{ fontFamily: fontFamily.primary }}>
            <ErrorBoundary errorAt="At General Service Request GeneralNavbar">
                <GeneralNavbar history={props.history} />
            </ErrorBoundary>

            <div className="row p-3 px-5" style={{ background: "rgba(184, 247, 255, 0.3)" }}>
                <div className="col-md-8 col-12 mt-5">
                    <h1 id="service-registration-heading" className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>Service Registration</h1>
                    <p id="desc-para" style={{ fontSize: "1.2rem", maxWidth: "400px" }}>
                        Contact the Service Expert by providing your information.
                        <br />
                        The details for the session, then shall be discussed over mail/phone.
                    </p>
                </div>
                <img id="contact-us-img" className="col-md-4 col-12" src={ContactUsImg} alt="img" />
            </div>


            <div className="mb-5 py-5 col-md-8 mt-5 offset-md-2" style={theme.form}>
                <ErrorBoundary errorAt="At General ContactUs Form">
                    <form className="px-5" onSubmit={handleSubmit}>
                        <h2 id="registration-form-heading" className="formTitle text-center" style={{ color: colors.primary }}>Registration</h2>
                        <br />

                        <label id="registration-name-label" for="name" style={theme.formBodyText} >Name </label>
                        <input type="text"
                            id="name"
                            name="name"
                            value={serviceRequest.requester.name}
                            onChange={handleChange}
                            className="form-control"
                            required
                            style={theme.formInput}
                        />
                        <br />

                        <label id="registration-email-label" for="email" style={theme.formBodyText} >Email </label>
                        <input type="text"
                            id="email"
                            name="email"
                            value={serviceRequest.requester.email}
                            onChange={handleChange}
                            className="form-control"
                            required
                            style={theme.formInput}
                        />
                        <br />

                        <label id="registration-institution-label" for="institution-name" style={theme.formBodyText} >Institution/Organisation Name (if any) </label>
                        <input type="text"
                            id="institution-name"
                            name="institution-name"
                            value={serviceRequest.institution.name}
                            onChange={handleChange}
                            className="form-control"
                            style={theme.formInput}
                        />
                        <br />

                        <label id='registration-institution-email-label' for="institution-email" style={theme.formBodyText} >Institution/Organisation Email (if any) </label>
                        <input type="text"
                            id="institution-email"
                            name="institution-email"
                            value={serviceRequest.institution.email}
                            onChange={handleChange}
                            className="form-control"
                            style={theme.formInput}
                        />
                        <br />

                        <label id='registration-requested-service-label' for="selected-service" style={theme.formBodyText} >Requested Service </label>
                        <input type="text"
                            id="selected-service"
                            name="selected-service"
                            value={requestedServiceName}
                            className="form-control"
                            style={theme.formInput}
                            disabled
                        />
                        <br />

                        <label id='registration-message-label' for="message" style={theme.formBodyText} >Message </label>
                        <textarea
                            id="message"
                            rows="10"
                            name="message"
                            value={serviceRequest.message}
                            onChange={handleChange}
                            className="form-control"
                            required
                            style={theme.formInput}
                        />
                        <br />



                        <button className="btn mx-auto mt-3" id="submit-btn" type="submit" style={theme.button} disabled={isLoading}>
                            {isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Register
                        </button>

                        <p id="note-para" className="mt-3" style={theme.paragraphMDSM}>*Note: We will get back to you within 2 business days</p>

                    </form>
                </ErrorBoundary>

            </div>
            <Footer />
        </div>
    )

}

export default ServiceRequest;